export default "__VITE_ASSET__BKAsBIGY__"